import React, { useEffect, useState } from "react";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import RadioGroup from "@enerex/unified-ui-react/form/RadioGroup";
import Select from "@enerex/unified-ui-react/form/Select";
import FormInput from "components/FormInput/index";
import { CommodityIcon } from "../CommodityIcons";
import { getStateDisplayName, getStateOptionValue } from "../utilityUtils";
const FormatModal = ({ show, record, onHide, onSave, states = [], allowedCommodityIds = [1, 2], saving }) => {
  const [form, setForm] = useState({
    CommodityId: 1,
    Pattern: "",
    Regex: "",
    Remark: "",
  });

  useEffect(() => {
    if (show) setForm(record ? {
      Id: record.id ?? record.Id ?? 0,
      UtilitiesId: record.utilitiesId ?? record.UtilitiesId ?? record.utilityId ?? record.UtilityId ?? 0,
      CommodityId: Number(record.commodityId ?? record.CommodityId ?? 1),
      StateId: record.stateId ?? record.StateId ?? "",
      Pattern: record.pattern || record.Pattern || "",
      Regex: record.regex || record.Regex || "",
      Remark: record.remark || record.Remark || "",
    } : { CommodityId: allowedCommodityIds[0] ?? 1, StateId: "", Pattern: "", Regex: "", Remark: "" });
  }, [show, record, allowedCommodityIds]);

  const stateOptions = states.map((s) => ({
    value: getStateOptionValue(s),
    label: getStateDisplayName(s),
  }));

  const selectedStateId = form.StateId || (states.length ? getStateOptionValue(states[0]) : "");

  const commodityOptions = [
    {
      id: "format-commodity-1",
      value: 1,
      label: (
        <span className="d-inline-flex align-items-center gap-1">
          <CommodityIcon type="electric" />
        </span>
      ),
    },
    {
      id: "format-commodity-2",
      value: 2,
      label: (
        <span className="d-inline-flex align-items-center gap-1">
          <CommodityIcon type="gas" />
        </span>
      ),
    },
  ].filter((option) => allowedCommodityIds.includes(Number(option.value)) || (record && Number(option.value) === Number(form.CommodityId)));

  return (
    <ConfirmationModal
      dialogClassName="modal-md"
      centered
      show={show}
      onHide={onHide}
      title={record ? "Edit Utility Format" : "Utility Format"}
      confirmButtonLabel={saving ? "Saving..." : record ? "Save" : "Add Utility Format"}
      confirmButtonVariant="primary"
      isLoading={saving}
      onConfirm={() => {
        if (!selectedStateId || !form.Pattern.trim() || !form.Regex.trim()) return;
        onSave({ ...form, StateId: selectedStateId });
      }}
    >
        <div className="mb-3">
          <RadioGroup
            inline
            name="format-commodity"
            options={commodityOptions}
            value={form.CommodityId}
            onChange={(value) => setForm((f) => ({ ...f, CommodityId: Number(value) }))}
          />
        </div>
        <div style={{ alignItems: "flex-start", display: "grid", gap: 16, gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
          <div>
            <div>
              <label style={{ display: "block", marginBottom: 8 }}>
                State <span style={{ color: "#fa5c7c" }}>*</span>
              </label>
              <Select
                options={stateOptions}
                value={stateOptions.find((o) => String(o.value) === String(selectedStateId)) || null}
                isDisabled
                placeholder="Select..."
                isClearable={false}
                getOptionValue={(option) => String(option.value)}
                getOptionLabel={(option) => option.label}
                menuPortalTarget={document.body}
              />
            </div>
          </div>
          <div>
            <FormInput
              type="text"
              label={<>Pattern <span style={{ color: "#fa5c7c" }}>*</span></>}
              labelClassName="mb-2"
                value={form.Pattern}
                onChange={(e) => setForm((f) => ({ ...f, Pattern: e.target.value }))}
                placeholder="Enter Pattern"
              />
          </div>
        </div>

        <FormInput
          type="text"
          label={<>Regex <span style={{ color: "#fa5c7c" }}>*</span></>}
          containerClass="mb-3 mt-3"
            value={form.Regex}
            onChange={(e) => setForm((f) => ({ ...f, Regex: e.target.value }))}
            placeholder="Enter Regex"
          />

        <FormInput
          type="textarea"
          label="Remark"
            rows={2}
            value={form.Remark}
            onChange={(e) => setForm((f) => ({ ...f, Remark: e.target.value }))}
            placeholder="Enter Remark"
          />
    </ConfirmationModal>
  );
};

export default FormatModal;

